import WalletAccountItemList from './WalletAccountItemList';
import WalletAccountItemShow from './WalletAccountItemShow.js';

const walletAccountItems = {
	list: WalletAccountItemList,
	show: WalletAccountItemShow
};

export default walletAccountItems;
